/**
 *
 * This function is used to prevent undefined or null value
 * Value can be undefined or null or string or number
 * In any case, should accept number equals to 0
 */
export const noUndefinedNoNull = <T extends string | number | boolean | unknown[] | null | undefined>(value: T): string | number | boolean => {
  if (typeof value === "object" && value !== null) {
    try {
      return JSON.stringify(value, getCircularReplacer(), 2);
    } catch {
      return "[Serialization Error]";
    }
  }
  return value ?? "";
};

export const getCircularReplacer = () => {
  const seen = new WeakSet<object>();
  return (_key: string, value: any) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return "[Circular]";
      }
      seen.add(value);
    }
    return value;
  };
};

